import * as Yup from "yup";

export const voteQuestionSchema = Yup.object().shape({
  title: Yup.object({
    uz: Yup.string().required("Majburiy"),
    ru: Yup.string().required("Majburiy"),
    en: Yup.string().required("Majburiy"),
  }),
  description: Yup.object({
    uz: Yup.string().required("Majburiy"),
    ru: Yup.string().required("Majburiy"),
    en: Yup.string().required("Majburiy"),
  }),
});
